export default "__VITE_ASSET__C_sMZ7Sy__"